import { BRAND_NAME } from "./_variable";

const configMap = {
    staging: {
        brandName: "antos",
        // backendURL: "https://adminapi.antospnc.app/",
        // graphqlURL: "https://adminapi.antospnc.app/graphql",
        // backendURL: "https://admin.worthycodes.com/",
        // graphqlURL: "https://admin.worthycodes.com/graphql",
        backendURL: "http://localhost:41960/",
        graphqlURL: "http://localhost:41960/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 2,
        assetsURL: "https://assets.nextrades.ai",
        mode: "development",
        mt5PositionSocket: "wss://me3.nextrades.ai",
    },
    fundamarkets: {
        brandName: "fundamarkets",
        backendURL: "https://admin.fundamarkets.app/",
        graphqlURL: "https://admin-web.fundamarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 6,
        mode: "development",
    },
    excotrades: {
        brandName: "excotrades",
        backendURL: "https://admin.excotrades.app/",
        graphqlURL: "https://admin-web.excotrades.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 2,
        mode: "development",
    },
    metapromarkets: {
        brandName: "metapromarkets",
        backendURL: "https://admin.metapromarkets.app/",
        graphqlURL: "https://admin-web.metapromarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 3,
        mode: "development",
    },
    ridgewaymarkets: {
        brandName: "ridgewaymarkets",
        backendURL: "https://admin.ridgewaymarkets.app/",
        graphqlURL: "https://admin-web.ridgewaymarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 4,
        mode: "development",
    },
    alliumtrades: {
        brandName: "alliumtrades",
        backendURL: "https://admin.alliumtrades.app/",
        graphqlURL: "https://admin-web.alliumtrades.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        defaultLayout: 6,
        mode: "development",
    },
    minosmarkets: {
        brandName: "minosmarkets",
        backendURL: "https://admin.minosmarkets.app/",
        graphqlURL: "https://admin-web.minosmarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        cmsURL: "minosbrokers.com",
        defaultLayout: 5,
        mode: "development",
    },
    cronoscap: {
        brandName: "cronoscap",
        backendURL: "https://admin.cronoscap.app/",
        graphqlURL: "https://admin-web.cronoscap.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        cmsURL: "cronoscap.com",
        defaultLayout: 5,
        mode: "development",
    },
    quorvex: {
        brandName: "quorvex",
        backendURL: "https://admin.qvmarkets.app/",
        graphqlURL: "https://admin.qvmarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "qvmarkets",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        // TEMPORARY — the liveness routes are not deployed on the AP backend's
        // /api/ms/verification proxy yet (it answers 403 upstreamStatus), so the
        // liveness calls go straight to the microservice. Delete this key once the
        // proxy carries them and they will fall back to the proxied base.
        verificationDirectURL: "https://verification.qvmarkets.app/api",
        defaultLayout: 3,
        mode: "development",
    },
    blueocean: {
        brandName: "blueocean",
        backendURL: "https://admin.blueoceanfin.app/",
        graphqlURL: "https://admin.blueoceanfin.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.nextrades.ai/api",
        assetsURL: "https://assets.nextrades.ai",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        assetsBrandName: "blueocean",
        defaultLayout: 1,
        mode: "development",
        mt5PositionSocket: "wss://me1.nextrades.ai",
    },
    antos: {
        brandName: "antos",
        backendURL: "https://admin-old.antospnc.app/",
        graphqlURL: "https://admin-web-old.antospnc.app/graphql",
        // backendURL: "https://admin.worthycodes.com/",
        // graphqlURL: "https://admin-web.worthycodes.com/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.antospnc.app/api",
        mt5WebSocket: "wss://xsocket.antospnc.app",
        defaultLayout: 2,
        mode: "development",
    },
    antospnc: {
        brandName: "antos",
        backendURL: "https://admin.antospnc.app/",
        graphqlURL: "https://admin.antospnc.app/graphql",
        // backendURL: "https://admin.worthycodes.com/",
        // graphqlURL: "https://admin-web.worthycodes.com/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.antospnc.app/api",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "antospnc",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        mt5WebSocket: "wss://xsocket.antospnc.app",
        defaultLayout: 2,
        mode: "development",
        mt5PositionSocket: "wss://me2.nextrades.ai",
    },
    // AP International (member.antospinnacles.co) — its own brand, separate from antospnc
    // (antospnc.asia / antos-pinnacles.com) and antos, with its own Admin Panel
    // backend. Microservices go through that backend's /api/ms proxy
    // (src/config/microserviceApis.js), so no per-service URLs here.
    apinternational: {
        brandName: "apinternational",
        backendURL: "https://admin.antospinnacles.co/",
        graphqlURL: "https://admin.antospinnacles.co/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        // TODO(AP-153): same MT5 server as antospnc and there is no mt5./xsocket. host on
        // antospinnacles.co, so these are antospnc's endpoints — confirm before go-live.
        tradeURL: "https://mt5.antospnc.app/api",
        mt5WebSocket: "wss://xsocket.antospnc.app",
        mt5PositionSocket: "wss://me2.nextrades.ai",
        assetsURL: "https://assets.nextrades.ai",
        // assetsBrandName is the asset-service folder for client uploads (KYC, signatures,
        // avatars) and the log brand tag, so it stays the brand's own, never antospnc's.
        // TODO(AP-153): no AP International artwork yet, so it borrows Antos Pinnacles':
        // themeBrandName selects public/brand/color/antos, and the brand views fall
        // through via `case "apinternational"` in src/brand/*/view/index.js.
        assetsBrandName: "apinternational",
        themeBrandName: "antos",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        defaultLayout: 2,
        mode: "development",
    },
    dearc: {
        brandName: "dearc",
        backendURL: "https://admin.dearc.app/",
        graphqlURL: "https://admin.dearc.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.nextrades.ai/api",
        defaultLayout: 5,
        mode: "development",
    },
    // Internal DEV environment (member.worthycodes.com). Every microservice is
    // proxied through the AP backend (`${backendURL}api/ms/<service>`), so no
    // verificationDirectURL here. Brand assets fall back to the pxmarkets set —
    // worthycodes has none of its own on the CDN.
    worthycodes: {
        brandName: "worthycodes",
        backendURL: "https://admin.worthycodes.com/",
        graphqlURL: "https://admin.worthycodes.com/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        tradeURL: "https://mt5.nextrades.ai/api",
        mt5WebSocket: "wss://xsocket.nextrades.ai",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "pxmarkets",
        // Reuse the pxmarkets theme files and brand views instead of duplicating
        // them: public/brand/color/pxmarkets + the `case "worthycodes"` fall-
        // throughs in src/brand/*/view/index.js.
        themeBrandName: "pxmarkets",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        defaultLayout: 3,
        mode: "development",
    },
    pxmarkets: {
        brandName: "pxmarkets",
        backendURL: "https://admin.pxmarkets.app/",
        graphqlURL: "https://admin.pxmarkets.app/graphql",
        instrumentsURL: "https://instruments.nextrades.ai/graphql",
        assetsURL: "https://assets.nextrades.ai",
        assetsBrandName: "pxmarkets",
        strategyBuilderURL: "https://strategybuilder.nextrades.ai",
        defaultLayout: 3,
        mode: "development",
        mt5PositionSocket: "wss://me3.nextrades.ai",
    },
    // Add more configuration mappings for different names
};

function getConfigByName() {
    const config = configMap[BRAND_NAME];
    if (config) {
        return config;
    } else {
        // Return a default configuration or handle the case when the name is not found
        return null;
    }
}

export default getConfigByName;
